const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";

export function getDeviceModel(): string {
  if (!ua) return "Unknown";

  // Chrome (includes Edge Chromium)
  const chromeMatch = ua.match(/Chrome\/([\d.]+)/);
  if (chromeMatch && /Edg\//.test(ua)) {
    const edgeMatch = ua.match(/Edg\/([\d.]+)/);
    return `Edge ${edgeMatch ? edgeMatch[1].split(".")[0] : ""}`;
  }
  if (chromeMatch) return `Chrome ${chromeMatch[1].split(".")[0]}`;

  // Firefox
  const firefoxMatch = ua.match(/Firefox\/([\d.]+)/);
  if (firefoxMatch) return `Firefox ${firefoxMatch[1].split(".")[0]}`;

  // Safari
  const safariMatch = ua.match(/Version\/([\d.]+).*Safari/);
  if (safariMatch) return `Safari ${safariMatch[1].split(".")[0]}`;

  // IE
  const ieMatch = ua.match(/Trident\/.*rv:([\d.]+)/);
  if (ieMatch) return `IE ${ieMatch[1].split(".")[0]}`;

  // Opera / Opera Mini
  const operaMatch = ua.match(/(?:Opera|OPR)\/([\d.]+)/);
  if (operaMatch) return `Opera ${operaMatch[1].split(".")[0]}`;

  return "Unknown Browser";
}

export function getDeviceOs(): string {
  if (!ua) return "Unknown";

  // Windows
  const windowsMatch = ua.match(/Windows NT ([\d.]+)/);
  if (windowsMatch) {
    const winVersions: Record<string, string> = {
      "10.0": "Windows 10",
      "6.3": "Windows 8.1",
      "6.2": "Windows 8",
      "6.1": "Windows 7",
      "6.0": "Windows Vista",
      "5.1": "Windows XP",
    };
    return winVersions[windowsMatch[1]] || `Windows ${windowsMatch[1]}`;
  }

  // macOS
  const macMatch = ua.match(/Mac OS X ([\d_]+)/);
  if (macMatch) {
    const version = macMatch[1].replace(/_/g, ".");
    return `macOS ${version}`;
  }

  // iOS
  const iosMatch = ua.match(/OS ([\d_]+)/);
  if (iosMatch && /iPhone|iPad|iPod/.test(ua)) {
    const version = iosMatch[1].replace(/_/g, ".");
    return `iOS ${version}`;
  }

  // Android
  const androidMatch = ua.match(/Android ([\d.]+)/);
  if (androidMatch) return `Android ${androidMatch[1]}`;

  // Linux (generic)
  if (/Linux/.test(ua)) return "Linux";

  return "Unknown OS";
}
